import { proposalStatusInfo } from 'app/helpers/proposal-status';
import { AfterViewInit, Component, HostListener, Input, OnInit, Output, ViewChild, EventEmitter, OnChanges, SimpleChanges, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { DatePipe } from '@angular/common';
import { BehaviorSubject, from, Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { Client } from 'app/entities';
import { ProposalService } from 'app/main/pages/proposals/proposals.service';
import { debounceTime, distinctUntilChanged, finalize, map, takeUntil } from 'rxjs/operators';
import { StringFilterByPipe } from 'app/string-filter-by.pipe';
import { FilterFieldComponent } from 'app/layout/components/table/table.component';
import { MatMenuTrigger } from '@angular/material/menu';
import * as moment from 'moment';
import { CustomerState } from 'app/state/customer/customer.reducer';
import { Store } from '@ngrx/store';
import { selectCustomers } from 'app/state/customer/customer.select';
import { loadCustomers } from 'app/state/customer/customer.actions';
import { UsersService } from 'app/main/pages/users/users.service';
import { AccountState } from 'app/state/account/account.reducer';
import { selectAccount, selectTags } from 'app/state/account/account.selectors';
import { Account } from 'app/entities/account';
import { AccountTag } from 'app/entities/account-tag';
import { formatBRL } from 'app/helpers/money';

// Filtro aplicado, exibido como chip removível fora do painel (ex.: "Tag: cartão ×")
export interface ActiveFilterChip {
    key: string;
    value?: any;
    label: string;
    // ordenação aparece como chip, mas não conta como filtro (não restringe resultados)
    restricts: boolean;
}

// Campos que restringem resultados e voltam ao vazio ao limpar. O período do relatório
// (report_*) fica de fora: tem botão próprio no cabeçalho e é mantido ao limpar.
const RESTRICTING_DEFAULTS = {
    status: [],
    tags: [],
    client_id: null,
    customer_id: null,
    start_date: null,
    end_date: null,
    start_value: null,
    end_value: null,
};

const DEFAULT_SORT = 'created_at';

@Component({
    selector: 'app-proposals-filter',
    templateUrl: './proposals-filter.component.html',
    styleUrls: ['./proposals-filter.component.scss']
})
export class ProposalsFilterComponent implements OnInit, FilterFieldComponent, AfterViewInit, OnChanges, OnDestroy {

    @ViewChild('filterMenuTrigger') filterMenuTrigger!: MatMenuTrigger;
    @ViewChildren(MatSelect) selects?: QueryList<MatSelect>;
    @Output() onFilter = new Subject();
    @Output("onFiltered") onFiltered = new EventEmitter<any>();
    @Input("saveFilters") saveFilters = false
    @Input("savedFiltersKey") savedFiltersKey = 'saved-filters'
    @Input("showClients") showClients = true
    @Input("showTags") showTags = true
    @Input("showSort") showSort = true
    @Input("showStatus") showStatus = true

    @Input("buttonName") buttonName = "Filtros"
    @Input("cardTitle") cardTitle = "Opções de Filtros"
    // Variante do botão (design system): on-brand no cabeçalho azul, tonal em cards brancos
    @Input() variant: 'on-brand' | 'tonal' = 'on-brand'
    @Input("hideFields") hideFields: string[] = [
        'report_start_date',
        'report_end_date',
    ]
    @Input() allowDeletedStatus = false;
    @Input() defaultFilters: any = null;

    customers$: Observable<CustomerState> = this.store.select(selectCustomers);

    tags$: Observable<AccountTag[]> = new Observable<AccountTag[]>(observer => {
        this.storeAccount.select(selectTags).subscribe(tags => {
            observer.next(tags)
        })
    });

    filters: any = {};
    form!: FormGroup;
    clientsFiltered: ReplaySubject<Client[]> = new ReplaySubject<Client[]>(1);
    // ORCA-1971: paginação dos clientes
    clientsLoading = false;
    private clientPage = 0;
    private clientHasMore = false;
    private clientsRequest?: Subscription;
    private selectedClient?: Client;
    usuariosFiltered: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    filtersUpdated: BehaviorSubject<any> = new BehaviorSubject(null);

    public dateFilterFields = [
        {
            "name": "Data de criação",
            "field": "created_at"
        },
        {
            "name": "Data de envio",
            "field": "sented_at"
        },
        {
            "name": "Data de aprovação",
            "field": "approved_at"
        },
        {
            "name": "Data de pagamento",
            "field": "paid_at"
        }
    ]

    public sorts = [
        {
            "name": "Valor crescente (>)",
            "field": "total_liquid"
        },
        {
            "name": "Valor decrescente (<)",
            "field": "-total_liquid"
        },
        {
            "name": "Data de criação - Mais recente",
            "field": "-created_at"
        },
        {
            "name": "Data de criação - Mais antiga",
            "field": "created_at"
        },
        {
            "name": "Data de envio - Mais recente",
            "field": "-sented_at"
        },
        {
            "name": "Data de envio - Mais antiga",
            "field": "sented_at"
        },
        {
            "name": "Data de aprovação - Mais recente",
            "field": "-approved_at"
        },
        {
            "name": "Data de aprovação - Mais antiga",
            "field": "approved_at"
        },
        {
            "name": "Data de pagamento - Mais recente",
            "field": "-paid_at"
        },
        {
            "name": "Data de pagamento - Mais antiga",
            "field": "paid_at"
        },
        {
            "name": "Data de faturamento - Mais recente",
            "field": "-billed_at"
        },
        {
            "name": "Data de faturamento - Mais antiga",
            "field": "billed_at"
        },
        {
            "name": "Data de vencimento - Mais recente",
            "field": "-date_proposal"
        },
        {
            "name": "Data de vencimento - Mais antiga",
            "field": "date_proposal"
        },
    ]

    clients
    usuarios

    public bankFilterCtrl: FormControl = new FormControl();
    public usuariosFilterCtrl: FormControl = new FormControl();
    private _onDestroy = new Subject<void>();

    menuOpen = false

    // Filtros aplicados (chips fora do painel); atualizados a cada aplicação
    activeFilters: ActiveFilterChip[] = [];
    private tagNames: Record<string, string> = {};

    private baseStatusItems: Record<string, string> = {
        1: "Criado",
        2: "Enviado",
        3: "Aprovado",
        4: "Reprovado",
        5: "Faturado",
        6: "Pago",
        7: "Expirado",
    }

    statusItems: Record<string, string> = { ...this.baseStatusItems };

    // Opções do filtro de status com a bolinha da cor do status (design system)
    statusDotClass(status: string): string {
        const info = proposalStatusInfo(status);
        return info ? `oa-status--${info.key}` : '';
    }


    constructor(
        private _formBuilder: FormBuilder,
        private _proposalsService: ProposalService,
        private stringFilterByPipe: StringFilterByPipe,
        private userService: UsersService,
        private store: Store<CustomerState>,
        private storeAccount: Store<AccountState>,
    ) { }


    // Esc fecha o menu de filtros. Ao abrir com clique o foco fica no botão (fora do painel),
    // então o Esc não chegava ao mat-menu. Se um select/calendário do filtro estiver aberto,
    // o Esc fecha só ele.
    @HostListener('document:keydown.escape')
    onEscape(): void {
        if (!this.filterMenuTrigger?.menuOpen) {
            return;
        }

        if (document.querySelector('.cdk-overlay-container .mat-select-panel, .cdk-overlay-container .mat-datepicker-content')) {
            return;
        }

        this.filterMenuTrigger.closeMenu();
    }

    // Esc com um select do painel aberto: o foco fica no mat-select (dentro do mat-menu),
    // então o Esc subia até o menu, que fechava e deixava a lista do select órfã por cima
    // da tela (com um fundo invisível bloqueando os toques). Fecha só o select.
    onPanelEscape(event: Event): void {
        const openSelect = this.selects?.find(select => select.panelOpen);
        if (openSelect) {
            event.stopPropagation();
            openSelect.close();
            openSelect.focus();
        }
    }

    ngAfterViewInit(): void {
        this.filterMenuTrigger.menuOpened.subscribe(() => {
            this.menuOpen = true
        })

        this.filterMenuTrigger.menuClosed.subscribe(() => {
            if (this.form.dirty) {
                this.apply()
            }

        })
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allowDeletedStatus'] || changes['showStatus']) {
            this.updateStatusItems();
        }

        if (changes['defaultFilters'] && this.form) {
            this.applyDefaultFilters(this.defaultFilters);
        }
    }

    ngOnInit(): void {

        // ORCA-1971: clientes por página, buscando no servidor (antes vinha a lista inteira da conta)
        this.bankFilterCtrl.valueChanges
            .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this._onDestroy))
            .subscribe(() => this.loadClientsPage(1));

        this.usuariosFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.filterUsuarios();
            });

        this.storeAccount.select(selectTags)
            .pipe(takeUntil(this._onDestroy))
            .subscribe(tags => {
                this.tagNames = {};
                (tags ?? []).forEach(tag => this.tagNames[String(tag.id)] = String(tag.name));
                this.refreshActiveFilters();
            });

        this.createForm();
        this.updateStatusItems();

        if (this.defaultFilters) {
            this.applyDefaultFilters(this.defaultFilters);
        }

        this.filtersUpdated
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.refreshActiveFilters());

        // nomes de cliente/usuário para os chips de filtros salvos
        if (this.filters?.client_id) {
            this.loadSelectedClient(this.filters.client_id);
        }
        this.form?.controls['client_id']?.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe((clientId) => {
                const client = (this.clients ?? []).find((item) => item.id == clientId);
                if (client) {
                    this.selectedClient = client;
                }
            });
        if (this.filters?.customer_id) {
            this.loadCustomers();
        }
    }

    ngOnDestroy(): void {
        this.clientsRequest?.unsubscribe();
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    onFilterMenuOpened() {
        this.laodClients()
        this.loadCustomers()
    }

    laodClients() {
        // A 1ª página só na primeira abertura do menu; a busca e a rolagem carregam o resto
        if (this.showClients && !this.clientPage && !this.clientsLoading) {
            this.loadClientsPage(1);
        }
    }

    private loadClientsPage(page: number): void {
        if (!this.showClients) {
            return;
        }
        const search = String(this.bankFilterCtrl.value || '').trim();
        this.clientsRequest?.unsubscribe();
        this.clientsLoading = true;
        this.clientsRequest = this._proposalsService.searchClients(search, page)
            .pipe(finalize(() => this.clientsLoading = false))
            .subscribe((res: any) => {
                const clients: Client[] = res?.data || [];
                this.clientPage = page;
                this.clientHasMore = (res?.meta?.current_page ?? page) < (res?.meta?.last_page ?? page);
                this.clients = page === 1
                    ? clients
                    : [...(this.clients ?? []), ...clients.filter((client) => !(this.clients ?? []).some((item) => item.id === client.id))];
                this.publishClients();
                this.refreshActiveFilters();
            });
    }

    /** Cliente de um filtro salvo: busca só ele, para o nome no chip e no select */
    private loadSelectedClient(clientId: number | string): void {
        if (!this.showClients || !clientId) {
            return;
        }
        this._proposalsService.searchClients('', 1, [Number(clientId)]).subscribe((res: any) => {
            this.selectedClient = (res?.data || [])[0];
            this.publishClients();
            this.refreshActiveFilters();
        });
    }

    /** O cliente escolhido continua no select mesmo fora da página/busca atual */
    private publishClients(): void {
        const list = this.clients ?? [];
        const selected = this.selectedClient;
        this.clientsFiltered.next(selected && !list.some((client) => client.id === selected.id) ? [selected, ...list] : list.slice());
    }

    onClientPanelToggle(opened: boolean, select: MatSelect): void {
        const panel: HTMLElement | undefined = (select as any)?.panel?.nativeElement;
        if (!panel) {
            return;
        }
        if (opened) {
            panel.addEventListener('scroll', this.onClientPanelScroll);
        } else {
            panel.removeEventListener('scroll', this.onClientPanelScroll);
        }
    }

    private readonly onClientPanelScroll = (event: Event) => {
        const panel = event.target as HTMLElement;
        if (!this.clientsLoading && this.clientHasMore && panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 80) {
            this.loadClientsPage(this.clientPage + 1);
        }
    };

    loadCustomers() {
        this.userService.simpleUsuariosAll().subscribe((customers) => {
            this.usuarios = customers;
            this.usuariosFiltered.next(this.usuarios.slice());
            this.refreshActiveFilters();
        })
    }

    createForm() {
        let formControlsValues = {
            status: [],
            tags: [],
            date_filter: "created_at",
            start_date: null,
            end_date: null,
            report_start_date: null,
            report_end_date: null,
            client_id: null,
            start_value: null,
            end_value: null,
            customer_id: null,
            sort: "created_at",
        }
        // remove fields that should be hidden
        this.hideFields.forEach(field => {
            delete formControlsValues[field]
        })

        this.form = this._formBuilder.group(formControlsValues)

        if (this.saveFilters) {
            var savedfilters = localStorage.getItem(this.savedFiltersKey);
            if (savedfilters) {
                this.filters = JSON.parse(savedfilters)
                // remove fields that should be hidden
                this.hideFields.forEach(field => {
                    delete this.filters[field]
                })
                this.setDefaultValues()
                this.form.patchValue(this.filters)
                if (this.getFilterCount() > 0) {
                    this.filtersUpdated.next(null)
                }
            }
        }
    }

    filterCount: Observable<number> = from(this.filtersUpdated).pipe(
        map(() => {
            return this.getFilterCount()
        })
    )

    // Só conta o que restringe resultados: ordenação e período do relatório não entram
    getFilterCount() {
        return this.buildActiveFilters().filter(chip => chip.restricts).length
    }

    get hasRestrictingFilters(): boolean {
        return this.activeFilters.some(chip => chip.restricts);
    }

    private refreshActiveFilters(): void {
        this.activeFilters = this.buildActiveFilters();
    }

    private buildActiveFilters(): ActiveFilterChip[] {
        const f = this.filters ?? {};
        const chips: ActiveFilterChip[] = [];
        const filled = (v) => v !== null && v !== undefined && v !== '';

        // status não editável (ex.: lista de excluídos) não é filtro do usuário
        if (this.showStatus && this.showFormControl('status')) {
            (f.status ?? []).forEach(status => chips.push({
                key: 'status', value: status, restricts: true,
                label: `Status: ${this.statusItems[status] ?? (status === 'deleted' ? 'Excluído' : status)}`,
            }));
        }

        if (this.showTags) {
            (f.tags ?? []).forEach(tagId => chips.push({
                key: 'tags', value: tagId, restricts: true,
                label: `Tag: ${this.tagNames[tagId] ?? '…'}`,
            }));
        }

        if (this.showClients && filled(f.client_id)) {
            const client = (this.clients ?? []).find(c => c.id == f.client_id)
                ?? (this.selectedClient?.id == f.client_id ? this.selectedClient : undefined);
            chips.push({ key: 'client_id', restricts: true, label: `Cliente: ${client?.name ?? '…'}` });
        }

        if (this.showClients && filled(f.customer_id)) {
            const user = (this.usuarios ?? []).find(u => u.id == f.customer_id);
            chips.push({ key: 'customer_id', restricts: true, label: `Usuário: ${user?.name ?? '…'}` });
        }

        if (this.showFormControl('start_date') && (filled(f.start_date) || filled(f.end_date))) {
            const field = this.dateFilterFields.find(d => d.field === f.date_filter)?.name ?? 'Data';
            chips.push({ key: 'date', restricts: true, label: `${field}: ${this.rangeLabel(this.formatDay(f.start_date), this.formatDay(f.end_date))}` });
        }

        // R$ 0 não restringe nada (mesmo critério do contador antigo)
        if (this.showFormControl('start_value') && (f.start_value || f.end_value)) {
            chips.push({ key: 'value', restricts: true, label: `Valor: ${this.rangeLabel(f.start_value ? formatBRL(f.start_value) : null, f.end_value ? formatBRL(f.end_value) : null)}` });
        }

        if (this.showSort && filled(f.sort) && f.sort !== DEFAULT_SORT) {
            const sort = this.sorts.find(s => s.field === f.sort)?.name ?? f.sort;
            chips.push({ key: 'sort', restricts: false, label: `Ordenar: ${sort.replace(' - ', ', ').replace('Mais', 'mais').replace(/\s*\([<>]\)/, '')}` });
        }

        return chips;
    }

    private formatDay(value): string | null {
        return value ? moment(value).format('DD/MM/YYYY') : null;
    }

    private rangeLabel(start: string | null, end: string | null): string {
        if (start && end) {
            return `${start} a ${end}`;
        }
        return start ? `a partir de ${start}` : `até ${end}`;
    }

    // Remove um filtro pelo chip e aplica na hora
    removeFilter(chip: ActiveFilterChip): void {
        const controls = this.form.controls;
        switch (chip.key) {
            case 'status':
            case 'tags':
                controls[chip.key]?.setValue((controls[chip.key].value ?? []).filter(v => v != chip.value));
                break;
            case 'date':
                controls.start_date?.setValue(null);
                controls.end_date?.setValue(null);
                break;
            case 'value':
                controls.start_value?.setValue(null);
                controls.end_value?.setValue(null);
                break;
            case 'sort':
                controls.sort?.setValue(DEFAULT_SORT);
                break;
            default:
                controls[chip.key]?.setValue(null);
        }
        this.form.markAsDirty();
        this.apply();
    }

    // "Limpar filtros" fora do painel: remove tudo o que restringe e a ordenação,
    // mas mantém o período do relatório (que tem botão próprio)
    clearFilters(): void {
        const values = { ...RESTRICTING_DEFAULTS, sort: DEFAULT_SORT };
        Object.keys(values).forEach(key => this.form.controls[key]?.setValue(values[key]));
        this.form.markAsDirty();
        this.apply();
    }


    onStatusRemoved(status) {
        const statuses = this.statusControl.value as string[];
        this.removeFromArray(statuses, status);
        this.setFormControlValue(null, 'status', statuses);
    }

    onTagRemoved(tagId) {
        const tags = this.tagsControl.value as AccountTag[];
        this.removeFromArray(tags, tagId);
        this.setFormControlValue(null, 'tags', tags);
    }

    private removeFromArray<T>(array: T[], toRemove: T): void {
        const index = array.indexOf(toRemove);
        if (index !== -1) {
            array.splice(index, 1);
        }
    }

    get statusControl() {
        return this.form.controls?.status
    }

    get tagsControl() {
        return this.form.controls?.tags
    }

    getTagById(tagId): Observable<AccountTag | undefined> {
        return this.tags$.pipe(
            map(tags => tags.find(tag => tag.id == tagId))
        )
    }

    private updateStatusItems(): void {
        this.statusItems = { ...this.baseStatusItems };
    }

    private applyDefaultFilters(filters: any): void {
        if (!filters || !this.form) {
            return;
        }
        this.form.patchValue(filters, { emitEvent: false });
        this.form.markAsDirty();
        this.apply();
    }

    setFormControlValue($event, controlName: string, value: any) {
        $event?.stopPropagation()
        if (this.form.controls[controlName]) {
            this.form.controls[controlName].setValue(value)
            this.form.markAsDirty()
        }

        this.setDefaultValues()
    }

    setDefaultValues() {
        console.log("0", this.filters);
        Object.keys(this.filters).forEach(key => {
            if (key == 'report_start_date' && !this.filters[key]) {
                console.log('setting default report_start_date');

                this.form.controls[key].setValue(moment().subtract(1, 'months'))
                this.filters[key] = moment().subtract(1, 'months').format('YYYY-MM-DD')
            }

            if (key == 'report_end_date' && !this.filters[key]) {
                this.form.controls[key].setValue(moment())
                this.filters[key] = moment().format('YYYY-MM-DD')
            }
        })

        if (this.saveFilters) {
            console.log("salvando filtros", this.filters)
            localStorage.setItem(this.savedFiltersKey, JSON.stringify(this.filters));
        }

    }

    apply(): void {
        //ONLY APPLY FILTER IF FORM IS DIRTY
        if (this.form.dirty) {

            //switch start and end intervals if both are set, and min max are in wrong positions
            //correct for valor
            if (this.form.controls?.start_value?.value && this.form.controls?.end_value?.value) {
                if (this.form.controls?.start_value.value > this.form.controls?.end_value.value) {
                    //switch values
                    var start = this.form.controls?.start_value.value
                    this.form.controls?.start_value.setValue(this.form.controls?.end_value.value)
                    this.form.controls?.end_value.setValue(start)
                }
            }

            //correct for date
            if (this.form.controls?.start_date?.value) {
                this.form.controls?.start_date.setValue(moment(this.form.controls?.start_date?.value))
            }
            if (this.form.controls?.end_date?.value) {
                this.form.controls?.end_date.setValue(moment(this.form.controls?.end_date?.value))
            }
            if (this.form.controls?.report_start_date?.value) {
                this.form.controls?.report_start_date.setValue(moment(this.form.controls?.report_start_date?.value))
            }
            if (this.form.controls?.report_end_date?.value) {
                this.form.controls?.report_end_date.setValue(moment(this.form.controls?.report_end_date?.value))
            }
            if (this.form.controls?.start_date?.value && this.form.controls?.end_date?.value) {
                if (this.form.controls?.start_date?.value.isAfter(this.form.controls?.end_date?.value)) {
                    //switch values
                    var start = this.form.controls?.start_date.value
                    this.form.controls?.start_date.setValue(this.form.controls?.end_date.value)
                    this.form.controls?.end_date.setValue(start)
                }
            }
            if (this.form.controls?.report_start_date?.value && this.form.controls?.report_end_date?.value) {
                if (this.form.controls?.report_start_date?.value.isAfter(this.form.controls?.report_end_date?.value)) {
                    //switch values
                    var start = this.form.controls?.report_start_date.value
                    this.form.controls?.report_start_date.setValue(this.form.controls?.report_end_date.value)
                    this.form.controls?.report_end_date.setValue(start)
                }
            }

            this.filters = {
                ...this.form.value,
                // start_date: this.formatDate(this.form.value.start_date),
                // end_date: this.formatDate(this.form.value.end_date),
                start_date: this.form.value.start_date?.format('YYYY-MM-DD') ?? null,
                end_date: this.form.value.end_date?.format('YYYY-MM-DD') ?? null,
                report_start_date: this.form.value.report_start_date?.format('YYYY-MM-DD') ?? null,
                report_end_date: this.form.value.report_end_date?.format('YYYY-MM-DD') ?? null,
                sort: this.form.value.sort ?? null,
            }

            // console.log(this.filters);


            this.filtersUpdated.next(null)

            //save filters
            if (this.saveFilters) {
                localStorage.setItem(this.savedFiltersKey, JSON.stringify(this.filters));
            }

            this.form.markAsPristine();
            this.form.markAsUntouched();

            this.onFilter.next(this.filters)
        }
        if (this.filterMenuTrigger.menuOpen) {
            this.filterMenuTrigger.closeMenu()
        }

        if (this.onFiltered) {
            this.onFiltered.emit(this.filters)
        }

    }

    reset() {
        this.form.reset()
        this.form.markAsDirty()
        // TODO: reset date filter to created_at nao funciona, da um erro que o filtro nao existe, verificar inpacto de colocar safe null aqui
        this.form.controls['date_filter']?.setValue('created_at')
        this.form.controls['sort']?.setValue('created_at')
        this.setDefaultValues()
        this.apply()
        this.filterMenuTrigger.closeMenu()
    }

    filterUsuarios() {
        if (!this.usuarios) {
            return;
        }
        // get the search keyword
        let search = this.usuariosFilterCtrl.value;
        if (!search) {
            this.usuariosFiltered.next(this.usuarios.slice());
            return;
        } else {
            search = search.toLowerCase();
        }
        // filter the banks
        this.usuariosFiltered.next(
            this.stringFilterByPipe.transform(this.usuarios, search, "name")
        );
    }

    showFormControl(controlName: string) {
        if (this.hideFields.includes(controlName)) {
            return false
        }
        return true
    }
}
